import React, { useState } from "react";
import styles from "./index.module.css";
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  Hidden,
  ListItemIcon,
} from "@material-ui/core";
import Sidebar from "./sidebar";
import { Route, Link, BrowserRouter as Router, Switch } from "react-router-dom";
import Course from "./Course";
import Course_Outcome from "./Course_Outcome";
import Co_Po_Maping from "./Co_Po_Maping";
import Manage_Topic_Tlos from "./Manage_Topic_Tlos";
import Manage_Lab_Experiment_Tlos from "./Manage_Lab_Experiment_Tlos";

const Index = () => {
  return (
    <Router>
      <Grid container>
        <Hidden mdDown>
          <Grid item lg={3} className={styles.sidebarWrapper}>
            <Sidebar />
          </Grid>
        </Hidden>
        <Grid item lg={9}>
          <Switch>
            <Route exact path="/curriculum" component={Course} />
            <Route
              exact
              path="/curriculum/course-outcome"
              component={Course_Outcome}
            />
            <Route
              exact
              path="/curriculum/co-po-maping"
              component={Co_Po_Maping}
            />
            <Route
              exact
              path="/curriculum/manage-topic-tlos"
              component={Manage_Topic_Tlos}
            />
            <Route
              exact
              path="/curriculum/manage-lab-experiment-tlos"
              component={Manage_Lab_Experiment_Tlos}
            />
          </Switch>
        </Grid>
      </Grid>
    </Router>
  );
};

export default Index;
